export const setTableCellWidth = () => {
    const tableCells = document.querySelectorAll('.table__cell');

    if (tableCells.length > 0) {
        // Find the maximum width of the elements
        let maxWidth = 0;

        tableCells.forEach(cell => {
            // Get the natural width of each element
            const cellWidth = cell.offsetWidth;
            if (cellWidth > maxWidth) {
                maxWidth = cellWidth;
            }
        });

        // Apply the maximum width to all elements
        tableCells.forEach(cell => {
            cell.style.width = `${maxWidth}px`;
        });
    }
}